import React, { useState, useEffect } from 'react';
import 'suneditor/dist/css/suneditor.min.css';

import InfoPopoverComments from '../InfoPopoverComments';

export default function InfoPopoverCommentsWrapper({ dashboardComments, section, title }) {
  const [dashboardComment, setDashboardComment] = useState(null);

  const generateUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    );
  };

  const findComment = async (dashboardComments, titleTextParam, dashboardSectionText) => {
    try {
      // Create a Set to track unique identifiers
      const uniqueIdentifiers = new Set();
      const uniqueComments = dashboardComments?.filter((comment) => {
        const identifier = `${comment?.dashboardSectionText}-${comment?.titleText}`;
        if (!uniqueIdentifiers.has(identifier)) {
          uniqueIdentifiers.add(identifier);
          return true;
        }
        return false;
      });

      // Filter comments that match the titleTextParam and dashboardSectionText
      const filteredComments = uniqueComments?.filter(
        (comment) =>
          comment?.dashboardSectionText === dashboardSectionText &&
          comment?.titleText === titleTextParam,
      );

      // Check if filteredComments is empty, if so, call createMyCommentObj

      return filteredComments.length > 0
        ? filteredComments
        : [createMyCommentObj(dashboardSectionText, titleTextParam)];
    } catch (error) {
      console.error('Error in findComment:', error);
      return [];
    }
  };

  function createMyCommentObj(dashboardSectionText, titleTextParam) {
    if (titleTextParam?.toLowerCase() === 'header') {
      return {
        comment: '',
        commentId: generateUUID(),
        dashboardSectionText: dashboardSectionText,
        titleText: titleTextParam,
      };
    } else {
      return {
        comment: '',
        commentId: generateUUID(),
        dashboardSectionText: dashboardSectionText,
        titleText: titleTextParam,
      };
    }
  }

  useEffect(() => {
    const fetchDashboardComment = async () => {
      const comment = await findComment(dashboardComments, section, title);
      setDashboardComment(comment);
    };

    fetchDashboardComment();
  }, [dashboardComments, section, title]);

  return <InfoPopoverComments dashBoardComment={dashboardComment?.[0]} />;
}
